import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "color", "size", "style", "width", "height", "opacity"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
var IconBase = function IconBase(_ref) {
  var children = _ref.children,
    color = _ref.color,
    size = _ref.size,
    style = _ref.style,
    width = _ref.width,
    height = _ref.height,
    _ref$opacity = _ref.opacity,
    opacity = _ref$opacity === void 0 ? 0.84 : _ref$opacity,
    props = _objectWithoutProperties(_ref, _excluded);
  var computedSize = size || '1em';
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet",
    height: height || computedSize,
    width: width || computedSize
  }, props, {
    style: _objectSpread({
      opacity: opacity,
      verticalAlign: 'middle',
      color: color
    }, style)
  }), children);
};
export default IconBase;